<template>
	<div class="type-filters is-hidden-mobile" v-if="!isEmpty && !backLink">
		<div class="container" role="complementary" aria-label="Product Categories">
			<div class="columns">
				<div class="column is-one-quarter">
					<image-card-new
						:background="isFilterSelected({facetName: 'Feature', facetValue: 'Bundles'}) ? '/images/pages/search/selectedBg.jpg' : '/images/pages/search/bundles.png'"
						:overlay="true"
						:overlay-gradient="false"
						title="Bundles"
						:height="80"
						:title-size="18"
						@click.native="toggleFilter({facetName: 'Feature', facetValue: 'Bundles'})"
					>
					</image-card-new>
				</div>
				<div class="column is-one-quarter">
					<image-card-new
						:background="isFilterSelected({facetName: 'Feature', facetValue: 'New'}) ? '/images/pages/search/selectedBg.jpg' : '/images/pages/search/new.png'"
						:overlay="true"
						:overlay-gradient="false"
						title="New"
						:height="80"
						:title-size="18"
						@click.native="toggleFilter({facetName: 'Feature', facetValue: 'New'})"
					>
					</image-card-new>
				</div>
				<div class="column is-one-quarter">
					<image-card-new
						:background="isFilterSelected({facetName: 'Feature', facetValue: 'Bestsellers'}) ? '/images/pages/search/selectedBg.jpg' : '/images/pages/search/bestsellers.png'"
						:overlay="true"
						:overlay-gradient="false"
						title="Bestsellers"
						:height="80"
						:title-size="18"
						@click.native="toggleFilter({facetName: 'Feature', facetValue: 'Bestsellers'})"
					>
					</image-card-new>
				</div>
				<div class="column is-one-quarter">
					<image-card-new
						:background="isFilterSelected({facetName: 'Feature', facetValue: 'NSF Certified for Sport'}) ? '/images/pages/search/selectedBg.jpg' : '/images/pages/search/nsf.png'"
						:overlay="true"
						:overlay-gradient="false"
						title="NSF Certified for Sport&reg;"
						:height="80"
						:title-size="18"
						@click.native="toggleFilter({facetName: 'Feature', facetValue: 'NSF Certified for Sport'})"
					>
					</image-card-new>
				</div>
			</div>
		</div>
	</div>
</template>
	
<script>
	import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
	import ImageCardNew from "../features/ImageCardNew.vue";

	export default {
		name: "CategoryFilters",
		components: { ImageCardNew },
		
		computed: {
			...mapState("search", ["backLink"]),
		    ...mapGetters("search", ["isEmpty", "isFilterSelected"])
		},
		
		methods: {
			...mapActions("search", ["toggleFilter"])
		}
	}
</script>
